import Pauta from '../components/Pauta';

export default function PautaRegistro() {
  return <Pauta statusPauta="Aguardando Registro" colunas={['Protocolo']} corPauta="#f57c00" />;
}